import { useCallback, useState } from "react";
import styled from "styled-components";
import { BASIC_DARK_GRAY, BASIC_WHITE } from "../../../constants/colors";
import { Time } from "../../../utils/time";
import { PickUpTimeForm } from "../../organisms/form/PickUpTimeForm";

type Props = {
  selectableTime: Time[];
  onSelect: (hour: number, minute: number) => void;
  disabled: boolean;
  selectedTime?: Time;
  defaultOpen?: boolean;
};

export const PickUpTimeSelect: React.FC<Props> = ({
  selectableTime,
  onSelect,
  disabled,
  selectedTime,
  defaultOpen,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(defaultOpen ?? false);

  const handleOnClick = useCallback(() => {
    if (disabled) return;

    setIsOpen((prev) => !prev);
  }, [disabled]);

  return (
    <PickUpTimeSelectContainer disabled={disabled}>
      <PickUpTimeSelectText onClick={handleOnClick}>
        <Text>時間を指定する</Text>

        <Icon>
          <IconLine></IconLine>
          {!isOpen && <IconLine $vertical></IconLine>}
        </Icon>
      </PickUpTimeSelectText>

      {isOpen && (
        <>
          <PickUpTimeForm
            selectableTime={selectableTime}
            handleSubmit={(hour, minute) =>
              onSelect(Number(hour), Number(minute))
            }
            selectedTime={selectedTime}
          />
        </>
      )}
    </PickUpTimeSelectContainer>
  );
};

const PickUpTimeSelectContainer = styled.div<{ disabled: boolean }>`
  text-align: left;
  border: 1px solid ${BASIC_DARK_GRAY};
  background-color: ${BASIC_WHITE};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.2 : 1)};
`;

const PickUpTimeSelectText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  p {
    line-height: 1em;
  }
`;

const Icon = styled.div`
  position: relative;
  width: 15px;
  height: 15px;
`;

const IconLine = styled.span<{ $vertical?: boolean }>`
  position: absolute;
  top: 7px;
  left: 0;
  margin: 0;
  padding: 0;
  font-size: 0;
  display: inline-block;
  background-color: ${BASIC_DARK_GRAY};
  width: 15px;
  height: 1px;
  transform-origin: center center;
  transform: ${({ $vertical }) =>
    $vertical ? "rotate(90deg)" : "rotate(0deg)"};
`;

const Text = styled.p`
  font-size: 16px;
  font-weight: 600;
`;
